"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TournamentBracketSeedOrdering = void 0;
var TournamentBracketSeedOrdering;
(function (TournamentBracketSeedOrdering) {
    TournamentBracketSeedOrdering["InnerOuter"] = "inner_outer";
    TournamentBracketSeedOrdering["Natural"] = "natural";
    TournamentBracketSeedOrdering["Reverse"] = "reverse";
    TournamentBracketSeedOrdering["HalfShift"] = "half_shift";
    TournamentBracketSeedOrdering["ReverseHalfShift"] = "reverse_half_shift";
    TournamentBracketSeedOrdering["PairFlip"] = "pair_flip";
    TournamentBracketSeedOrdering["EffortBalanced"] = "groups.effort_balanced";
    TournamentBracketSeedOrdering["SeedOptimized"] = "groups.seed_optimized";
    TournamentBracketSeedOrdering["BracketOptimized"] = "groups.bracket_optimized";
})(TournamentBracketSeedOrdering = exports.TournamentBracketSeedOrdering || (exports.TournamentBracketSeedOrdering = {}));
//# sourceMappingURL=tournament-bracket-seed-ordering.js.map